<template>
  <div>

    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <!-- <v-toolbar-title class="white--text">TF > {{toolBarTitle}}(s)</v-toolbar-title> -->
      <v-toolbar-title class="white--text">Select Type
        <div class="toolbar-subtitle">
          <div class="subtitle-text dark-opacity-color">{{toolBarTitle}}</div>
        </div>
      </v-toolbar-title>

      <!-- <v-spacer></v-spacer> -->
      <!-- <v-btn round-borders outline @click="fn_new">New</v-btn> -->
      <!-- <v-btn icon @click="fn_getBottomMenu(901)"><v-icon>more_vert</v-icon></v-btn> -->

      <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    </v-toolbar>

    <div class="display_msg" v-if="!filteredItems.length">No Items</div>

    <div style="background-color:#F0F0F0;" class="hasToolbar hasExtension">
      <v-list style="margin-bottom:10px;padding:0">
        <div v-for="(item, index) in filteredItems" :key="index">
          <v-list-tile @click="fn_edit(item.transactionTypeFormId)">
            <v-list-tile-content>
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
            </v-list-tile-content> 
            <v-list-tile-action>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action> 
            <!-- <v-list-tile-action>
                <v-btn icon flat @click="fn_getBottomMenu(902, item.transactionTypeFormId)"><v-icon>more_vert</v-icon></v-btn>
            </v-list-tile-action> -->
          </v-list-tile>

          <v-divider v-if="filteredItems.length-1 != index"></v-divider>
        </div>
      </v-list> 
    </div>
  </div>
</template>

<script>
var tagId = null;
const transactionForms = require('../../../config.js').configs.transactionForms;
const bottomSheetMenu = require('../../../config.js').configs.bottomSheetMenu;
const menuItem = require('../../../config.js').configs.menuItem;
const transactionTypes = require('../../../config.js').configs.transactionTypes;

  export default{
    data(){
      return{
        transactionTypeId:null,
        // transactionTypeName:null,
        toolBarTitle:null,
        listItems:[],
        searchValue:'',
        scrollPositionTop:0,
        selectedItemId:null
      }
    },
    methods:{
      fn_new: function () {
        this.$router.push({path:"/settings/transaction/"+this.transactionTypeId+'/new', query:{tagId:this.guidWeb()}});
      },

      fn_initializeSettings: function () {
        this.transactionTypeId = Number(this.$route.params.typeId);
        // this.transactionTypeName = this.$route.params.typeName;
        for(let i=0;i<transactionForms.length;i++){
          if(transactionForms[i].id == this.transactionTypeId){
            this.toolBarTitle = transactionForms[i].title;
            break;
          }
        }
      },

      fn_goBack: function(){
        this.$router.go(-1);
      },

      fn_menuItemClick: function(tagId, menuId, menuAction){
        if(menuAction=='new'){
          this.fn_new();
        }
        else if(menuAction=='edit'){
          this.fn_edit(this.selectedItemId);
        }
        else if(menuAction=='copy'){
          this.$router.push({path:"/settings/transaction/"+this.transactionTypeId+'/new', query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
        }
      },

      fn_edit: function (itemId) {
        this.$router.push("/settings/transaction/"+this.transactionTypeId+"/"+itemId);
      },

      fn_getBottomMenu: function (elementId, itemId) {

        itemId ? this.selectedItemId = itemId : '';

        let bottomMenu;

        if(elementId == bottomSheetMenu.toolBar.Id){
          bottomMenu = {"BottomMenu": [menuItem.help]};
        }
        else if(elementId == bottomSheetMenu.masterListItems.Id){
          bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]};
        }

        this.setBottomMenu(tagId, bottomMenu, 
          {
            onSuccess: function (response) {
              console.log(response);
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },


      fn_getItems: function () {
        let filterObject = {};
        filterObject.type = this.transactionTypeId;
        //transaction types will not appear whose tagged account group status = 2
        //we also can add more statuses which we want to hide
        filterObject.accountGroupsHidden = [2];
        if(this.transactionTypeId == transactionTypes.expense.id && this.$root.CurrentBusiness.GSTRegistrationStatus != 1){
          filterObject.inventory = [0];
        }
        // filterObject.inventory = [0, 1];
        // filterObject.accountGroupStatus = 1;

        let self = this;
        this.getItems("TransactionTypeList", filterObject, 
          {
            onSuccess: function (response) {
              console.log(response);
              self.listItems = JSON.parse(response);
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },

      fn_showWebView: function () {
        var viewObject = {};
        var self = this;
        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null,
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            } 
          }
        );
      },
    },
    mounted: function () {
      tagId = this.$route.params.typeId;
      this.fn_initializeSettings();
      this.fn_showWebView();
      this.fn_getItems();
      window.js_globals.fn_onBackPress = this.fn_goBack;

      let self = this;
      document.addEventListener('scroll', function () {
        self.scrollPositionTop = window.pageYOffset
      })
    },
    computed:{
      filteredItems: function () {
        let searchText = this.searchValue.toLowerCase();

        return this.listItems.filter(item => {
          let transactionItem = item.name.toLowerCase();
          return transactionItem.match(searchText);
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/transaction/transaction_type_items.vue